import { render, staticRenderFns } from "./SystemVideo.vue?vue&type=template&id=78e06b8e&scoped=true"
import script from "./SystemVideo.vue?vue&type=script&lang=js"
export * from "./SystemVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e06b8e",
  null
  
)

export default component.exports